import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { Subscription } from 'rxjs';
declare var $:any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent {

  subscription =<any> Subscription;
  public loginTrue:boolean= false;
  public loginDetail:any =[];
  public urlTrue:boolean = false;
  public NotificationDetail : any =[];
  public dataCount : any =1;
  public noti_length :any = 0;
  public pagecount: any = 1;
  public UnreadCount : any=0;
  public loginImage:any='';
  public search:any='';
  public viewClose:boolean=false


  constructor(public router: Router, public service: GlobalService) {
    // this.service.sideIcon();
    if(localStorage.getItem('hva_login')){
      // this.getEnquryCount();
      this.subscription = this.service.getSubject().subscribe((message:any)=>{
        this.loginDetail=message.loginData;
      })
      this.loginTrue = true;
      this.loginDetail = JSON.parse(localStorage.getItem('hva_login') || "{}");
      if(this.loginDetail.image =='' || this.loginDetail.image ==undefined){       
        this.loginImage ='assets/images/avatars/avatar-2.png';
      } else {
        this.loginImage = this.loginDetail.image;
      }
    }
    }

   ngOnInit(): void {
    if(localStorage.getItem('hva_serchView')){
      var mm :any =localStorage.getItem('hva_serchView');
      if(mm==1){
        this.urlTrue = true;
      } else {
        this.urlTrue = false;
      }      
    }
   }

   getEnquryCount(){
    var url = '/contact-us?page=1';
    this.service.GetApi(url).subscribe(((response : any) => {
      if(response.success==1){ 
        localStorage.setItem('hva_Inqurycount',response.unreadCount) ;     
      } else{
      }
    }))
  }


  close(){
    $('#CONFIRMPopup1').modal('toggle');
  }

  searchText(type:any){
    if(type==1){
      this.viewClose=true;
      localStorage.setItem('hva_serachText',this.search);
      this.router.navigate(['/search']);  
    } else {
      this.viewClose= false;
      this.search='';
      localStorage.removeItem('hva_serachText');
      this.router.navigate(['/dashboard']);  

    }
  }
}
